module.exports = "/_next/static/images/9591c812133b0efd2f7ce54191d760e8-open-graph-logo.png.webp";